<template>
  <div :class="Object.assign({ }, classes, { 'has-error': hasError, 'required': required && !disabled })">
    <label class="control-label" :for="inputId">{{ label }}</label>
  </div>
</template>

<style lang="scss" scoped>
  .required .control-label:after {
    content:"*";
    color: red;
  }
</style>

<script>

  export default {
    name: 'MetaLabel',

    props: {
      classes: {
        type: Object,
        required: false,
        default: function() {
          return {};
        },
      },      
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      inputId: {
        type: String,
        required: true,
      },
      hasError: {
        type: Boolean,
        required: false,
        default: false,
      },
      label: {
        type: String,
        required: true,
      },
      required: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

  };
</script>



// WEBPACK FOOTER //
// App.vue?52b614d5